import React, { useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import CustomTooltip from "@/components/Tooltip";
import useChatStore from "@/stores/useChatStore";
import { useBreakpoint } from "use-breakpoint";
import useGlobalStore from "@/stores/useGlobalStore";
import { BREAKPOINTS } from "@/constants/defaultValue";

const EMPTY_PLACEHOLDER = "Không có tiêu đề";

function ChatHistory() {
  const chatHistory = useChatStore((state) => state.chatHistory);
  const loadChatHistory = useChatStore((state) => state.loadChatHistory);
  const navigate = useNavigate();
  const { chatId } = useParams();
  const { breakpoint } = useBreakpoint(BREAKPOINTS);

  const handleNavigate = (chatId) => {
    useChatStore.setState({ conversationId: chatId, suggestedQuestions: [], reminderId: null });
    navigate(`/chat/${chatId}`);


    if (["xs", "sm", "md"].includes(breakpoint)) {
      useGlobalStore.setState({ navVisible: false });
    }
  };

  useEffect(() => {
    loadChatHistory();
  }, []);

  return (
    <div className="flex flex-col w-full">
      {chatHistory.map((group) => (
        <div key={group.groupName} className="mb-4">
          <div className="text-primary text-sm sticky top-0 bg-white py-1 z-10 font-medium">{group.groupName}</div>
          {group.items.map((item, idx) => (
            <CustomTooltip tooltipContent={item.subject || EMPTY_PLACEHOLDER} key={item.id}>
              <Button
                key={item.id}
                variant={item.id === Number(chatId) ? "secondary" : "ghost"}
                className={`w-full text-left justify-start px-2 py-1 font-normal slide-up`}
                style={{ animationDelay: `${idx * 80}ms` }}
                onClick={() => handleNavigate(item.id)}
              >
                <span className="truncate block">{item.subject || EMPTY_PLACEHOLDER}</span>
              </Button>
            </CustomTooltip>
          ))}
        </div>
      ))}
    </div>
  );
}

export default ChatHistory;
